export const formatNumber = (num: number) => {
    return Intl.NumberFormat('en-US', {
        notation: "compact",
        maximumFractionDigits: 1
    }).format(num);
}

export const formatCurrency = (
    num: number,
    currency: string = 'USD',
    trailingZeroDisplay: 'stripIfInteger' | 'auto' | undefined = 'stripIfInteger'
) => {
    return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        trailingZeroDisplay: trailingZeroDisplay
    }).format(num);
}

export const formatTime = (num: number) => {
    var unit = "second";
    var amount = num;
    if (num >= 1000 * 60) {
        unit = "hour";
        amount = num / (60 * 60);
    } else if (num >= 1000) {
        unit = "minute";
        amount = num / 60;
    }
    return Intl.NumberFormat('en-US', {
        style: 'unit',
        unit: unit,
        maximumFractionDigits: 0,
        roundingMode: 'floor'
    }).format(amount);
}

export const formatDateTime = (num: number) => {
    return new Date(num * 1000).toLocaleString([], {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
}

export const formatDate = (num: number) => {
    return new Date(num * 1000).toLocaleString([], {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short"
    });
}
